"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalAcceptanceDtoKindEnum = void 0;
exports.instanceOfLegalAcceptanceDto = instanceOfLegalAcceptanceDto;
exports.LegalAcceptanceDtoFromJSON = LegalAcceptanceDtoFromJSON;
exports.LegalAcceptanceDtoFromJSONTyped = LegalAcceptanceDtoFromJSONTyped;
exports.LegalAcceptanceDtoToJSON = LegalAcceptanceDtoToJSON;
exports.LegalAcceptanceDtoToJSONTyped = LegalAcceptanceDtoToJSONTyped;
/**
 * @export
 */
exports.LegalAcceptanceDtoKindEnum = {
    Terms: 'terms',
    Privacy: 'privacy'
};
/**
 * Check if a given object implements the LegalAcceptanceDto interface.
 */
function instanceOfLegalAcceptanceDto(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    if (!('version' in value) || value['version'] === undefined)
        return false;
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    if (!('acceptedAt' in value) || value['acceptedAt'] === undefined)
        return false;
    return true;
}
function LegalAcceptanceDtoFromJSON(json) {
    return LegalAcceptanceDtoFromJSONTyped(json, false);
}
function LegalAcceptanceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'],
        'version': json['version'],
        'documentId': json['documentId'],
        'acceptedAt': json['acceptedAt'],
    };
}
function LegalAcceptanceDtoToJSON(json) {
    return LegalAcceptanceDtoToJSONTyped(json, false);
}
function LegalAcceptanceDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'kind': value['kind'],
        'version': value['version'],
        'documentId': value['documentId'],
        'acceptedAt': value['acceptedAt'],
    };
}
